import { render, staticRenderFns } from "./statisticLegend.vue?vue&type=template&id=d532eb28&scoped=true"
import script from "./statisticLegend.vue?vue&type=script&lang=js"
export * from "./statisticLegend.vue?vue&type=script&lang=js"
import style0 from "./statisticLegend.vue?vue&type=style&index=0&id=d532eb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d532eb28",
  null
  
)

export default component.exports